import { AnimalRepository } from '../../repositories/AnimalRepository';
import api from '../../../../../../api';
import { IAnimal } from '../../entities/IAnimal';

type Arguments = {
  propriedade_id: string;
  animalsApi: IAnimal[];
};

export class CheckAPIAndDeleteAnimalUseCase {
  constructor(private animalsRepository: AnimalRepository) {}

  public async execute({
    propriedade_id,
    animalsApi,
  }: Arguments): Promise<void> {
    const animalsLocal = await this.animalsRepository.findByPropriedadeId(
      propriedade_id,
    );

    if (animalsLocal.length > animalsApi.length) {
      const deletedAnimals = animalsLocal
        .map(animal => {
          if (
            animalsApi.some(animalLocal => animal.id === animalLocal.id) ===
            false
          ) {
            return animal;
          }
        })
        .filter(animal => animal !== undefined) as IAnimal[];

      deletedAnimals.forEach(animal =>
        this.animalsRepository.delete(animal.id),
      );
    }
  }
}
